import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function createCheckout(originUrl, packageId = "oratio_draft") {
  const { data } = await api.post("/checkout/session", {
    package_id: packageId,
    origin_url: originUrl,
  });
  return data;
}

export async function getCheckoutStatus(sessionId) {
  const { data } = await api.get(`/checkout/status/${sessionId}`);
  return data;
}

export async function generateSpeech(payload) {
  const { data } = await api.post("/generate", payload);
  return data;
}

export async function generatePreview({ role, memory }) {
  const { data } = await api.post("/preview", { role, memory });
  return data;
}

export async function sendEmail({ session_id, recipient_email, text }) {
  const { data } = await api.post("/send-email", { session_id, recipient_email, text });
  return data;
}

export async function sendContact({ name, email, message }) {
  const { data } = await api.post("/contact", { name, email, message });
  return data;
}
